import React, { useContext } from 'react';
import { Select } from 'antd';
import SelectDropDown from '../../../common/icons/SelectDropDown';
import UserContext from '../../../contexts/user-context/UserProvider';
import { useParams } from 'react-router-dom';
import InstallmentsPageContext from '../../../contexts/installments-context/InstallmentsContext';
import useCustomApiRequest from '../../../custom-hooks/useCustomApiRequest';
import checkRes from '../../../utils/checkRes';
import getAllSaleInvoiceInstallmentsApi from '../../../apis/store-apis/installments-sale-invoice-apis/getAllSaleInvoiceInstallmentsApi';

const InstallmentsTableFilter = () => {
  const { user } = useContext(UserContext);
  const { Option } = Select;
  const params = useParams();
  const [, set] = React.useState({
    invoice_id: params.id,
    status: null
  });
  const { setAllFetchedInstallments, setIsLoading } = useContext(
    InstallmentsPageContext
  );

  async function handleChange(filterType, value) {
    set((prevState) => {
      if (filterType === 'status') {
        return {
          ...prevState,
          status: value
        };
      }
    });
  }

  const customApiRequest = useCustomApiRequest();
  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    customApiRequest(
      getAllSaleInvoiceInstallmentsApi(user?.token),
      (res) => {
        setIsLoading(false);
        if (checkRes(res) && res?.data?.data?.length >= 0) {
          const data = res.data.data;
          setAllFetchedInstallments(data);
        }
      },
      (error) => {
        setIsLoading(false);
      }
    );
  }

  return (
    <div className="custom-table-fitler warehouse-table-filter">
      <div className="form-excel-export-wrap">
        <form
          className="filter-form receipt-filter-form"
          onSubmit={handleSubmit}
        >
          <label className="receipt-filter-option-wrap">
            <span className="select-title">حالة القسط</span>
            <Select
              defaultValue={null}
              style={{ width: 172 }}
              onChange={(v) => handleChange('status', v)}
              suffixIcon={<SelectDropDown />}
              showSearch={true}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value={null}>جميع الاقســاط</Option>
              <Option value="1">تم دفع القسط</Option>
              <Option value="2">لم يتم الدفع</Option>
            </Select>
          </label>

          <button className="filter-submit-btn" type="submit">
            بحث
          </button>
        </form>
      </div>
    </div>
  );
};

export default InstallmentsTableFilter;
